export default "__VITE_ASSET__122131b2__"